export default "<h1>Admin Area</h1>\n\n<a routerLink=\"users\" routerLinkActive=\"active\">User Administration</a>\n"